import axios from 'axios';
import { AppConsts } from '../enums/AppConsts';
import {
  AccountChangeLanguageModel,
  AccountDetailsModel,
  ChangePasswordModel,
  DepositDetailsModel,
  IdentityVerificationModel
} from '../models/profile';

const baseUrl = `${process.env.BASE_SERVER_ADDRESS}/profile`;
const getToken = () => localStorage.getItem(AppConsts.AccessToken);
const getHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const GetAccountDetailsQuery = async () => {
  return await axios.get(`${baseUrl}/AccountDetails`, getHeaders());
};

export const GetAccountSecurityDetailsQuery = async () => {
  return await axios.get(`${baseUrl}/AccountSecurityDetails`, getHeaders());
};

export const UpdateAccountDetailsQuery = async (data: AccountDetailsModel) => {
  return await axios.put(`${baseUrl}/UpdateDetails`, data, getHeaders());
};

export const SetUserDepositDetailsQuery = async (data: DepositDetailsModel) => {
  return await axios.put(`${baseUrl}/SetUserDepositDetails`, data, getHeaders());
};

export const UpdateAccountLanguageQuery = async (data: AccountChangeLanguageModel) => {
  return await axios.put(`${baseUrl}/UpdatePlayerLanguage`, data, getHeaders());
};

export const ChangePasswordQuery = async (data: ChangePasswordModel) => {
  return await axios.patch(`${baseUrl}/ChangePassword`, data, getHeaders());
};

export const VerifyIdentityQuery = async (data: IdentityVerificationModel) => {
  return await axios.post(`${baseUrl}/VerifyIdentity`, data, getHeaders());
};

export const GetKycTokenQuery = async () => {
  return await axios.get(`${baseUrl}/GetKycToken`, getHeaders());
};

export const GetVerificationStatusQuery = async () => {
  return await axios.get(`${baseUrl}/VerificationStatus`, getHeaders());
};

export const StartKycRequest = async () => {
  const response = await axios.post(
    `${process.env.BASE_SERVER_ADDRESS}/kyc/start`,
    {},
    getHeaders()
  );
  return response.data;
};

export const StartKycWithDetailsRequest = async (input: DepositDetailsModel) => {
  const data = input !== undefined ? input : null;
  const response = await axios.post(
    `${process.env.BASE_SERVER_ADDRESS}/kyc/startWithDetails`,
    data,
    getHeaders()
  );
  return response.data;
};
